
























import Vue from "vue";

// Model
import { ClientProfileExtended } from "@/model/communication/users/FetchClientProfilesResponse";
import { Organization } from "@/model/data/organizations/Organization";

export default Vue.extend({
    data() {
        return {
            selectedProfiles: [],
        };
    },
    props: {
        organization: { type: Object as () => Organization, required: true },
        profiles: { type: Array as () => ClientProfileExtended[], required: true },
    },
    computed: {
        availableProfiles() {
            return this.profiles.map((p) => ({
                text: (p.name.includes(this.profileNameInternalString) ? p.name.substring(0, p.name.lastIndexOf(this.profileNameInternalString)) : p.name) + " (" + p.associatedHierarchyList.map((f) => "📁 " + f.name.replace("/", "Root")).join(", ") + ")",
                value: p.name,
            }));
        },
    },
    watch: {
        organization(newValue) {
            this.reset();
        },
    },
    methods: {
        reset() {
            this.selectedProfiles = this.profiles
                .filter((p) => p.organizationId == this.organization.id)
                .map((p) => ({
                    text: (p.name.includes(this.profileNameInternalString) ? p.name.substring(0, p.name.lastIndexOf(this.profileNameInternalString)) : p.name) + " (" + p.associatedHierarchyList.map((f) => "📁 " + f.name.replace("/", "Root")).join(", ") + ")",
                    value: p.name,
                }));
        },
    },
    mounted() {
        this.reset();
    },
});
